import { PolicyLayout } from "@/components/PolicyLayout";

const H = ({ children }) => <h2 className="font-heading text-xl sm:text-2xl font-700 text-slate-800 mt-8 first:mt-0">{children}</h2>;
const P = ({ children }) => <p className="mt-3 text-slate-600 font-600 leading-relaxed">{children}</p>;
const UL = ({ children }) => <ul className="mt-3 space-y-2 list-disc pl-5 text-slate-600 font-600">{children}</ul>;

const openPrefs = () => window.dispatchEvent(new Event("open-cookie-preferences"));

export default function CookiePolicy() {
  return (
    <PolicyLayout title="Cookie Policy" updated="Giugno 2026">
      <P>
        Questo sito utilizza cookie e tecnologie simili per garantire il corretto funzionamento, migliorare
        l'esperienza di navigazione e, previo consenso, per finalità statistiche e di marketing, in conformità
        al GDPR e alle Linee Guida del Garante Privacy italiano.
      </P>

      <H>Che cosa sono i cookie</H>
      <P>
        I cookie sono piccoli file di testo che i siti salvano sul dispositivo dell'utente. Possono essere
        "tecnici" (necessari) o di "profilazione/terze parti" (soggetti a consenso).
      </P>

      <H>Tipologie di cookie utilizzate</H>
      <P><strong className="text-slate-800 font-800">Cookie tecnici (necessari)</strong> — sempre attivi, non richiedono consenso. Garantiscono il funzionamento del sito e memorizzano le tue preferenze sui cookie.</P>
      <P><strong className="text-slate-800 font-800">Cookie statistici</strong> — ci aiutano a comprendere come viene utilizzato il sito in forma aggregata. Attivati solo con il tuo consenso.</P>
      <P><strong className="text-slate-800 font-800">Cookie di marketing</strong> — utilizzati per misurare le campagne e mostrare annunci pertinenti. Fornitori: Google Tag Manager (GTM-KG5V5JGP) e Google Ads (AW-18435552291). Attivati solo con il tuo consenso.</P>

      <H>Gestione del consenso</H>
      <P>
        Al primo accesso compare un banner che consente di <strong>accettare</strong>, <strong>rifiutare</strong> o
        <strong> personalizzare</strong> le categorie di cookie. Nessun cookie di statistica o marketing viene
        installato prima del tuo consenso.
      </P>
      <P>Puoi modificare le tue scelte in qualsiasi momento:</P>
      <button
        data-testid="cookie-policy-manage-btn"
        onClick={openPrefs}
        className="mt-3 inline-flex items-center rounded-full bg-rose-500 text-white px-6 py-3 font-800 hover:bg-rose-600 transition-colors"
      >
        Gestisci preferenze cookie
      </button>

      <H>Come disabilitare i cookie dal browser</H>
      <P>
        Puoi gestire o eliminare i cookie anche dalle impostazioni del tuo browser. La disattivazione dei cookie
        tecnici potrebbe compromettere alcune funzionalità del sito.
      </P>

      <H>Titolare e contatti</H>
      <P>
        Asilo Nido Per Amore — Via Strasburgo 3/b, San Donato Milanese (MI) 20097. Email:
        asilonidoperamore@gmail.com. Per maggiori dettagli sul trattamento dei dati consulta la Privacy Policy.
      </P>
    </PolicyLayout>
  );
}
